"use strict";

var SpreadsheetExportMapper = function(columnAttributes, columnTitles, transform) {
    this.columnAttributes = columnAttributes;
    this.columnTitles = columnTitles;
    this.transform = transform;
};

SpreadsheetExportMapper.prototype.map = function(objects, context) {
    return this.tsvFromRows(this.mapRows(objects, context));
};

SpreadsheetExportMapper.prototype.mapRows = function(objects, context) {
    var rowObjects = this.mapRowObjects(objects, context);
    var headerRow = [];
    _(this.columnAttributes).each(function(attribute) { headerRow.push(this.columnTitles[attribute] || attribute); }, this);
    var rows = [ headerRow ];
    _(rowObjects).each(function (rowObject) {
        var row = [];
        _(this.columnAttributes).each(function(attribute) { row.push(rowObject[attribute]); });
        rows.push(row);
    }, this);
    return rows;
};

SpreadsheetExportMapper.prototype.mapRowObjects = function(objects, context) {
    var rowObjects = [];
    _(objects).each(function(object) {
        var rowObject = {};
        _(this.columnAttributes).each(function (attribute) {
            rowObject[attribute] = object[attribute];
        }, this);
        if (this.transform) rowObject = this.transform(rowObject, object, context);
        if (rowObject) rowObjects.push(rowObject);
    }, this);
    return rowObjects;
};

SpreadsheetExportMapper.prototype.tsvFromRows = function(rows, excel) {
    var tsv = '';
    firstRow = true;
    _(rows).each(function (row) {
        for (var col = 0; col < row.length; col++) {
            if (typeof row[col] == 'boolean') row[col] = row[col] ? 'X' : '';
            if (typeof row[col] == 'string' && row[col].indexOf('\n') >= 0) {
                row[col] = '"' + row[col].replace(/"/g,'""') + '"';
            } else if (typeof row[col] == 'string' && excel) {
                row[col] = row[col].replace(/"/g,'""');
            } else if (typeof row[col] == 'string' && row[col].length >= 1) {
                row[col] = row[col].replace(/"/g,'\\"');
            }
            if (typeof row[col] == 'string' && row[col].length > 0 && !Core.specialJobExport && !firstRow) {
                if (row[col].indexOf('|') > 0) {
                    var value = row[col].split('|')[0];
                    if (!isNaN(value)) row[col] += '|forcetext';
                } else if (!isNaN(row[col])) {
                    row[col] += '|forcetext';
                }
            }
        }
        tsv += '\n' + row.join('\t');
        firstRow = false
    });
    return tsv.substring(1);
};

SpreadsheetExportMapper.prototype.tsvFromObjects = function(objects, context) {
    return this.tsvFromRows(this.mapRows(objects, context));
};

SpreadsheetExportMapper.prototype.excelFromObjects = function(objects, context) {
    return this.tsvFromRows(this.mapRows(objects, context), true);
};

